import axios from "axios";
import {BASE_API_URL} from "../../app/AppConfig";
import {CartOfferDto, Offer} from "../Entity/Offer";
import {PutItemToCartOfferRequest} from "../Entity/PutItemToCartRequest";
import {LocalParams} from "../../components/LocalParams";
import {CreateAccount} from "../User/Account/CreateAccountTypes";

export async function postOfferRequestRep(offer: Offer, dataCustomerOffer: CreateAccount): Promise<Offer[]> {
  try {
    const response = await axios.put<Offer[]>(
      `${BASE_API_URL}/quotation_request/validate`,
      {
        'tokenValue' : offer.tokenValue,
        'email': offer.email,
        'firstName': dataCustomerOffer.firstName,
        'lastName': dataCustomerOffer.lastName,
        'countryCode': dataCustomerOffer.countryCode,
        'notes': offer.notes,
      }
    );
    LocalParams.removeItem('tokenOfferCart')
    return response.data;
  }
  catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }
}

export async function addItemOfferToCartRep( putItemToCartOfferRequest: PutItemToCartOfferRequest): Promise<CartOfferDto> {
  const tokenOfferCart = LocalParams.getItem('tokenOfferCart');
  try {
    const response = await axios.post<CartOfferDto>(
      `${BASE_API_URL}/quotation_request/add-item`,
      {
        'variantCode' : putItemToCartOfferRequest.variantCode,
        'locale': putItemToCartOfferRequest.locale,
        'quantity' : putItemToCartOfferRequest.quantity,
        'tokenValue': tokenOfferCart
      }
    )
    LocalParams.setItem('tokenOfferCart', response.data.tokenValue);
    return response.data;
  }
  catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }
}

export async function getItemInOfferCartRep(tokenOfferCart: string | null | undefined): Promise<CartOfferDto[]> {
  try {
    const response = await axios.get<CartOfferDto[]>(
      `${BASE_API_URL}/quotation_request/${tokenOfferCart}`,
    );
    return response.data;
  }
  catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }
}

export async function removeItemInOfferCartRep(putItemToCartOfferRequest: PutItemToCartOfferRequest): Promise<CartOfferDto[]> {
  try {
    const response = await axios.put<CartOfferDto[]>(
      `${BASE_API_URL}/quotation_request/remove-item`,
      {
        'variantCode' : putItemToCartOfferRequest.variantCode,
        'tokenValue': putItemToCartOfferRequest.tokenValue
      }
    );
    return response.data;
  }
  catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }
}

export async function changeQuantityItemInOfferCartRep(variantCode: string, quantity: number, tokenValue: string): Promise<CartOfferDto[]> {
  try {
    const response = await axios.put<CartOfferDto[]>(
      `${BASE_API_URL}/quotation_request/change-item-quantity`,
      {
        'variantCode' : variantCode,
        'tokenValue': tokenValue,
        'quantity' : quantity,
      }
    );
    return response.data;
  }
  catch (err:any) {
    throw {code: err.response.data.code, message: err.response.data.message }
  }
}


export async function updateNotesInOfferCartRep(tokenValue: string, notes: string): Promise<CartOfferDto[]> {
  try {
    const response = await axios.put<CartOfferDto[]>(
      `${BASE_API_URL}/quotation_request/update-notes`,
      JSON.stringify({
        tokenValue: tokenValue,
        notes: notes
      }),
      { headers: { 'Content-Type': 'application/json' } }
    );
    return response.data;
  } catch (err: any) {
    throw { code: err.response?.data?.code, message: err.response?.data?.message };
  }
}
